import { createIconDefinition } from '../../../../cross-team-shared/icons/create-icon-definition';

export const lineIcon = createIconDefinition(
  'line',
  `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.1572 3.65476C18.4397 4.01805 18.3743 4.54161 18.011 4.82417L3.011 16.4908C2.64772 16.7734 2.12415 16.708 1.84159 16.3447C1.55904 15.9814 1.62448 15.4578 1.98777 15.1753L16.9878 3.50859C17.3511 3.22603 17.8746 3.29147 18.1572 3.65476Z" fill="#232426" fill-opacity="0.6"/>
</svg>
`,
);
